import { ROUTES } from "../constants";
import { UserRole } from "../constants";

export const EXTERNAL_ID_QUERY_PARAM = "externalId";

/**
 * Returns the patient profile path for a given internal patient id.
 */
export function getPatientProfilePath(patientId: number | string): string {
  return `/patients/${patientId}`;
}

/**
 * Returns the external-patient resolver path.
 */
export function getExternalPatientPath(externalId: string): string {
  return `/external-patient/${encodeURIComponent(externalId)}`;
}

/**
 * Appends externalId as a query param when present.
 */
export function appendExternalIdQuery(
  path: string,
  externalId: string | null | undefined,
): string {
  if (!externalId) {
    return path;
  }

  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${EXTERNAL_ID_QUERY_PARAM}=${encodeURIComponent(externalId)}`;
}

/**
 * Returns the home route to navigate to after successful login,
 * based on the user's role. When externalId is present (external patient
 * deep-link), returns to the resolver route so the patient can be loaded
 * with an authenticated request.
 */
export function getPostLoginRoute(
  roleId: number | null | undefined,
  externalId?: string | null,
): string {
  if (externalId) {
    return getExternalPatientPath(externalId);
  }

  if (roleId === UserRole.SuperAdmin) {
    return ROUTES.TENANT_MANAGEMENT;
  }
  return ROUTES.DASHBOARD;
}
